<template>
    <b-container>
        <b-row>
            <b-col lg="6" md="8">
                <div class="content">
                    <h1>
                        Graphic Design
                    </h1>
                    <p>
                        We provide startups with brand identity creation, including logo and offline / online graphic applications to power their brands.
                    </p>
                    <p>
                        We also work with corporate sector to provide new them with new graphic campaigns and promotional materials, with special focus on web-related material production, website and social media design.
                    </p>
                </div>
            </b-col>
            <b-col lg="6" md="4" class="image">
                <img src="../assets/img/graphic-design.svg" alt="Graphic Design">
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  export default {
    name: 'GraphicDesign',
  }
</script>

<style scoped>
</style>